module.exports = __webpack_public_path__ + "media/kuifeend.3bb19194.mp3";